// extracted by mini-css-extract-plugin
export default {"addAppsHeader":"AddAppsModal_addAppsHeader__06fs-","addAppsSubHeader":"AddAppsModal_addAppsSubHeader__FNNj4"};